import { render, staticRenderFns } from "./Backtop.vue?vue&type=template&id=6621f1a8&scoped=true"
import script from "./Backtop.vue?vue&type=script&lang=js"
export * from "./Backtop.vue?vue&type=script&lang=js"
import style0 from "./Backtop.vue?vue&type=style&index=0&id=6621f1a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6621f1a8",
  null
  
)

export default component.exports